import blessLogo from "@chainLogos/low-res/blessnet-logo.png";
import ethLogo from "@chainLogos/low-res/ethereum-logo.png";
import arbLogo from "@chainLogos/low-res/arbitrum-logo.png";
import optLogo from "@chainLogos/low-res/optimism-logo.png";
import baseLogo from "@chainLogos/low-res/base-logo.png";
import { StaticImageData } from "next/image";
import {
  MainnetChainExplorer,
  MainnetChainId,
  MainnetWormholeId,
  SepoliaChainExplorer,
  SepoliaChainId,
  SepoliaWormholeId,
} from "@/types/chain-data.types";
import { Network } from "alchemy-sdk";
import { isMainnet } from "@/constants/flags.constant";

export interface ChainData {
  chainName: string;
  ticker: string;
  logo: StaticImageData;
  chainId: number;
  wormholeId: number | null;
  explorerAddress: string;
  alchemyNetworkName: Network | null;
}

// WORMHOLESCAN EXPLORERS
export const WORMHOLESCAN_TX_BASE_LINK = "https://wormholescan.io/#/tx/";
export const WORMHOLESCAN_MAINNET_PARAM = "?network=Mainnet";
export const WORMHOLESCAN_TESTNET_PARAM = "?network=Testnet";

export const BLOCKCHAINS: ChainData[] = [
  {
    chainName: "Blessnet",
    ticker: "BLESS",
    logo: blessLogo,
    chainId: MainnetChainId.Blessnet,
    wormholeId: null,
    explorerAddress: MainnetChainExplorer.Blessnet,
    alchemyNetworkName: null, // No corresponding value in Network enum
  },
  {
    chainName: "Ethereum",
    ticker: "ETH",
    logo: ethLogo,
    chainId: MainnetChainId.Ethereum,
    wormholeId: MainnetWormholeId.Ethereum,
    explorerAddress: MainnetChainExplorer.Ethereum,
    alchemyNetworkName: Network.ETH_MAINNET,
  },
  {
    chainName: "Arbitrum",
    ticker: "ARB",
    logo: arbLogo,
    chainId: MainnetChainId.Arbitrum,
    wormholeId: MainnetWormholeId.Arbitrum,
    explorerAddress: MainnetChainExplorer.Arbitrum,
    alchemyNetworkName: Network.ARB_MAINNET,
  },
  {
    chainName: "Optimism",
    ticker: "OP",
    logo: optLogo,
    chainId: MainnetChainId.Optimism,
    wormholeId: MainnetWormholeId.Optimism,
    explorerAddress: MainnetChainExplorer.Optimism,
    alchemyNetworkName: Network.OPT_MAINNET,
  },
  {
    chainName: "Base",
    ticker: "BASE",
    logo: baseLogo,
    chainId: MainnetChainId.Base,
    wormholeId: MainnetWormholeId.Base,
    explorerAddress: MainnetChainExplorer.Base,
    alchemyNetworkName: Network.BASE_MAINNET,
  },
];

export const TEST_BLOCKCHAINS: ChainData[] = [
  {
    chainName: "Blessnet Sepolia",
    ticker: "BLESS",
    logo: blessLogo,
    chainId: SepoliaChainId.Blessnet,
    wormholeId: null,
    explorerAddress: SepoliaChainExplorer.Blessnet,
    alchemyNetworkName: null, // No corresponding value in Network enum
  },
  {
    chainName: "Ethereum Sepolia",
    ticker: "ETH",
    logo: ethLogo,
    chainId: SepoliaChainId.Ethereum,
    wormholeId: SepoliaWormholeId.Ethereum,
    explorerAddress: SepoliaChainExplorer.Ethereum,
    alchemyNetworkName: Network.ETH_SEPOLIA,
  },
  {
    chainName: "Arbitrum Sepolia",
    ticker: "ARB",
    logo: arbLogo,
    chainId: SepoliaChainId.Arbitrum,
    wormholeId: SepoliaWormholeId.Arbitrum,
    explorerAddress: SepoliaChainExplorer.Arbitrum,
    alchemyNetworkName: Network.ARB_SEPOLIA,
  },
  {
    chainName: "Optimism Sepolia",
    ticker: "OP",
    logo: optLogo,
    chainId: SepoliaChainId.Optimism,
    wormholeId: SepoliaWormholeId.Optimism,
    explorerAddress: SepoliaChainExplorer.Optimism,
    alchemyNetworkName: Network.OPT_SEPOLIA,
  },
  {
    chainName: "Base Sepolia",
    ticker: "BASE",
    logo: baseLogo,
    chainId: SepoliaChainId.Base,
    wormholeId: SepoliaWormholeId.Base,
    explorerAddress: SepoliaChainExplorer.Base,
    alchemyNetworkName: Network.BASE_SEPOLIA,
  },
];

export const BLOCKCHAINS_BY_NETWORK = isMainnet
  ? BLOCKCHAINS
  : TEST_BLOCKCHAINS;
